import { useParams } from 'react-router-dom';
import DetailPlanLinkLanding from './DetailPlanLinkLanding';
import { getLessonByUuids } from '../../../services/LessonService';

export const LESSON_PLAN_LINK_PATH = 'lesson-plan';

/**
 * Path inside the new Vizzle iframe that shows the activity detail plan page.
 */
export const buildActivityDetailsPath = (lessonId) => `/search-lessons/activity-details/${lessonId}`;

/**
 * Landing route for a shared activity "Detail Plan Link" (/lesson-plan/:lessonUuid).
 *
 * The public URL carries the lesson uuid because it is stable across re-versioning,
 * while the detail plan page inside the iframe is keyed by lesson id, so the uuid
 * is resolved through the lessons/details endpoint first.
 */
export default function LessonPlanLink() {
  const { lessonUuid } = useParams();

  const resolveTarget = async () => {
    const result = await getLessonByUuids([lessonUuid]);
    const lessons = result?.data?.data || [];
    const lessonId = lessons[0]?.id;
    return lessonId ? buildActivityDetailsPath(lessonId) : null;
  };

  return (
    <DetailPlanLinkLanding
      itemName='activity'
      returnPath={`/${LESSON_PLAN_LINK_PATH}/${lessonUuid}`}
      resolveTarget={resolveTarget}
    />
  );
}
